import createAction from 'loankeeper-common/helpers/createAction'
import actions from './actionTypes'

export const destroy = (instanceName) => createAction(actions.DESTROY, {}, { instanceName })

/* grid state */
export const reduceFilterModel = (instanceName, filterModel, customId = null) =>
  createAction(actions.gridState.REDUCE_FILTER_MODEL, { filterModel }, { instanceName, customId })

export const removeFilterColumn = (instanceName, colId, customId = null) =>
  createAction(actions.gridState.REMOVE_FILTER_COLUMN, { colId }, { instanceName, customId })

/* default selected */
export const makeDefaultSelectedTrue = (instanceName) =>
  createAction(actions.MAKE_DEFAULT_SELECTED_TRUE, {}, { instanceName })

/* selected row */
export const selectRow = (instanceName, row) => createAction(actions.selectedRow.SELECT, row, { instanceName })

export const deselectRow = (instanceName) => createAction(actions.selectedRow.DESELECT, {}, { instanceName })

/* sorted Column */
export const sortAscColumn = (instanceName, colName) =>
  createAction(actions.sortedColumn.SORT_ASC, colName, { instanceName })

export const sortDescColumn = (instanceName, colName) =>
  createAction(actions.sortedColumn.SORT_DESC, colName, { instanceName })

export const sortNoneColumn = (instanceName) => createAction(actions.sortedColumn.SORT_NONE, {}, { instanceName })
